(function (global){
'use strict';

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null);

/**
 * @ngInject
 */
function ResidenceController($scope, $http, apiResidence) {

  $scope.address = {};
  $scope.unavailableDays = [];
  $scope.localisationId = null;

  // Format du DatePicker
  $scope.format = 'dd/MM/yyyy';

  // Options DatePicker
  $scope.dateOptions = {
    formatYear: 'yyyy',
    startingDay: 1
  };

  // Remise à aujourd'hui du datepicker
  $scope.today = function() {
    $scope.dateDebutBefore = '';
    $scope.dateDebut = new Date();
    $scope.dateFin = new Date();
  };

  // Ouverture du Datepicker Debut
  $scope.openStart = function($event) {
    $event.preventDefault();
    $event.stopPropagation();

    if(!angular.isDate($scope.dateDebut) && $scope.dateDebut !== '') {
      $scope.dateDebut = $scope.transformDate($scope.dateDebut, 0);
    }
    $scope.dateDebutBefore = $scope.dateDebut;

    // Disable date before today
    $scope.minDate = new Date();
    // Disable date before today + 1 yeat
    $scope.maxDate = new Date().setFullYear(new Date().getFullYear() + 1);

    $scope.openedStart = true;
  };

  // Ouverture du Datepicker Fin
  $scope.openEnd = function($event) {
    $event.preventDefault();
    $event.stopPropagation();

    if(!angular.isDate($scope.dateFin) && $scope.dateFin !== '') {
      $scope.dateFin = $scope.transformDate($scope.dateFin, 0);
    }

    // Disable date before dateDebut
    if ($scope.dateDebut === '') {
      $scope.minDateFin = new Date();
    } else if(angular.isDate($scope.dateDebut)) {
      var year  = $scope.dateDebut.getFullYear();
      var month = $scope.dateDebut.getMonth();
      // Ajoute 1 jour par rapport à la date de début (pour rester au minimum 1 nuit)
      var day   = $scope.dateDebut.getDate() + 1;
      $scope.minDateFin = new Date(year, month, day);
    } else{
      // // Ajoute 1 jour par rapport à la date de début (pour rester au minimum 1 nuit)
      $scope.minDateFin = $scope.transformDate($scope.dateDebut, 1);
    }
    // Disable date before today + 1 yeat
    $scope.maxDate = new Date().setFullYear(new Date().getFullYear() + 1);

    $scope.openedEnd = true;
  };

  /**
   * [shiftingDate description] Si la date de début n'etait pas vide à l'ouverture du datepicket et qu'on a une date de fin
   * au changement de la date de début, je garde l'intervalle qu'il y avait avec la date de début saisie avant.
   * @return {[type]} [description]
   */
  $scope.shiftingDate = function(){
    if($scope.dateDebutBefore === '' || $scope.dateFin === '') {
      return;
    }

    if(!angular.isDate($scope.dateFin)) {
      $scope.dateFin = $scope.transformDate($scope.dateFin, 0);
    }

    if(!angular.isDate($scope.dateDebutBefore)) {
      $scope.dateDebutBefore = $scope.transformDate($scope.dateDebutBefore, 0);
    }

    var diff = [];
    var tmp = $scope.dateFin - $scope.dateDebutBefore;

    tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60;                    // Extraction du nombre de secondes

    tmp = Math.floor((tmp-diff.sec)/60);    // Nombre de minutes (partie entière)
    diff.min = tmp % 60;                    // Extraction du nombre de minutes

    tmp = Math.floor((tmp-diff.min)/60);    // Nombre d'heures (entières)
    diff.hour = tmp % 24;                   // Extraction du nombre d'heures

    tmp = Math.floor((tmp-diff.hour)/24);   // Nombre de jours restants
    diff.day = tmp;

    var year  = $scope.dateDebut.getFullYear();
    var month = $scope.dateDebut.getMonth();
    var day   = $scope.dateDebut.getDate() + diff.day;
    $scope.dateFin = new Date(year, month, day);

  };

  /**
   * [transformDate description]
   * @param  {string} dateFr Date au format français (par exemple : '22/07/1984')
   * @param  {Number} addDay [description]
   * @return {Date} newDate au format Date
   */
  $scope.transformDate = function(dateFr, addDay) {
    if (dateFr === null) {
      return '';
    }
    dateFr = dateFr.split('/');
    if (!angular.isDefined(addDay)) {
      addDay = 0;
    }
    var year  = parseInt(dateFr[2]);
    // le mois commence à 0 : https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Date
    var month = parseInt(dateFr[1]) - 1;
    var day   = parseInt(dateFr[0]) + addDay;
    var newDate = new Date(year, month, day);
    return newDate;
  };

  /**
   * Ajoute des class aux jours sélectionnés et à la période entre les deux jours
   */
  $scope.getDayClass = function(date, mode) {

    var _class = '';

    if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0,0,0,0);
        var today = new Date().setHours(0,0,0,0);

        if(!angular.isDate($scope.dateDebut) && $scope.dateDebut !== '') {
          $scope.dateDebut = $scope.transformDate($scope.dateDebut);
        }
        if(!angular.isDate($scope.dateFin) && $scope.dateFin !== '') {
          $scope.dateFin = $scope.transformDate($scope.dateFin);
        }

        var dateDebut = new Date($scope.dateDebut).setHours(0,0,0,0);
        var dateFin = new Date($scope.dateFin).setHours(0,0,0,0);

        if (dayToCheck === today) {
          _class += ' today';
        }
        if (dayToCheck === dateDebut) {
          _class += ' debut';
        }
        if (dayToCheck === dateFin) {
          _class += ' fin';
        }
        if (dayToCheck < dateFin && dayToCheck > dateDebut) {
          _class += ' pendant';
        }
        for (var i = 0; i < $scope.unavailableDays.length; i++) {
          var currentDay = new Date($scope.unavailableDays[i]).setHours(0,0,0,0);
          if (dayToCheck === currentDay) {
            _class += ' unavailabile';
          }
        }
    }

    return  _class;

  };

  /**
   * Ajoute des dates non cliquables lorsqu'aucun logement n'est disponible
   */
  $scope.dateDisabled = function(date, mode) {
    if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0,0,0,0);

        for (var i = 0; i < $scope.unavailableDays.length; i++) {
          var currentDay = new Date($scope.unavailableDays[i]).setHours(0,0,0,0);
          if (dayToCheck === currentDay) {
            return true;
          }
        }

    }
    return false;

  };


  var getUnavailabilities = function() {

    // dates extermes pour les indisponibilités
    var today = new Date();
    var _from = dateFns.format(today, 'YYYY-MM-DD');
    var _to = dateFns.format(dateFns.addDays(dateFns.addYears(today, 1), 1), 'YYYY-MM-DD');

    // this is ugly I think
    var currentType = angular.element('#search_localisationId option[value="'+$scope.localisationId+'"]').attr('data-type')

    var url;
    switch (currentType) {
      case 'city':
        url = Routing.generate('unavailabilities_city', {
          city: $scope.localisationId
        });
        break;
      case 'residence':
        url = Routing.generate('unavailabilities_residence', {
          residence: $scope.localisationId
        });
        break;
      default:
        url = Routing.generate('unavailabilities_all');
    }

    url += '?from=' + _from + '&to=' + _to;

    return $http.get(url)
  };

  $scope.$watch('localisationId', function(newValue) {
    console.log('watch localisationId');

    if (angular.isDefined(newValue) && newValue !== '') {
      $scope.setUnavailableDays();
    }
  });

  /**
   * [setUnavailableDays description]
   */
  $scope.setUnavailableDays = function(){
    console.log('setUnavailableDays');

    getUnavailabilities().then(function (data) {
      $scope.unavailableDays = data.data;
    });
  };
}
ResidenceController.$inject = ["$scope", "$http", "apiResidence"];

module.exports = ResidenceController;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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